export enum NumericRangeFilterParam {
	From = 'From',
	To = 'To',
}

export enum FilterParamKey {
	FitFor = 'fitFor',
	HousingMaterials = 'housingMaterials',
	Search = 'search',
	Page = 'page',
}
